import './styles/App.css';
import "./fonts/font.css";

import MainPage from './components/HomePage';
import NavBar from './components/navbar';
import ClientsList from './components/adminPages/ClientsList';
import UsageTaxonomy from './components/adminPages/UsageTaxonomy';
import AdminTabs from './components/adminPages/AdminTabs';
import BuildingTypes from './components/adminPages/BuildingTypes';
import MachineTypes from './components/adminPages/MachineTypes';
import UsersAdmin from './components/adminPages/UsersAdmin';
import ClientBuildingDashboard from './components/clientPages/ClientBuildingDashboard';
import ClientDashboard from './components/clientPages/ClientDashboard';
import ClientEquipments from './components/clientPages/ClientEquipments';
import ClientUsages from './components/clientPages/ClientUsages';
import ClientActionPlan from './components/clientPages/ClientActionPlan';
import ClientActionPlanV2 from './components/clientPages/actionPlan/ClientActionPlanV2';
import HydroEfficientEquipmentModule from './components/clientPages/actionPlan/modules/hydroEfficientEquipment/HydroEfficientEquipmentModule';
import RainwaterHarvestingModule from './components/clientPages/actionPlan/modules/rainwaterHarvesting/RainwaterHarvestingModule';
import ReutModule from './components/clientPages/actionPlan/modules/reut/ReutModule';
import AuditPageCreationClient from './components/auditPages/AuditPageCreationClient'
import AuditPageCreationBuilding from './components/auditPages/AuditPageCreationBuilding'
import AuditPageCreationSectionsAndRooms from './components/auditPages/AuditPageCreationSectionsAndRooms'
import WaterpointForm from './components/auditPages/WaterpointForm'
import AuditProgressPage from './components/auditPages/progress/AuditProgressPage'
import WaterOriginPage from './components/clientPages/waterOrigin/WaterOriginPage'
import CbsSitesPage from './components/toolsPages/CbsSitesPage'
import AuditProgressBar from './components/auditPages/progress/AuditProgressBar'
import { OnlineStatusProvider, useOnlineStatus } from './offline/ConnectivityContext'
import { useBeforeUnloadWarning } from './components/shared/useBeforeUnloadWarning'
import ErrorBoundary from './components/ErrorBoundary'
import { AuthProvider } from './auth/AuthContext'
import AuthGate from './auth/AuthGate'
import LoginPage from './auth/LoginPage'
import SetPasswordPage from './auth/SetPasswordPage'
import ForgotPasswordPage from './auth/ForgotPasswordPage'
import AccountPage from './auth/AccountPage'
import { recordVisit } from './utils/recentBuildings'

import { Fragment, useEffect, useState } from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
  useNavigate,
  useParams,
  useLocation
} from "react-router-dom";

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomePage />,
  },

  // Clients
  {
    path: "/clients",
    element: <ClientsListPage />,
  },

  // Outils : CBS de n'importe quel site (comparaison de l'annexe CBS du rapport), origine probable de l'eau potable d'un bâtiment.
  {
    path: "/outils/cbs",
    element: <CbsSitesToolPage />,
  },
  {
    path: "/outils/origine-eau",
    element: <WaterOriginPagePage />,
  },

  // Admin (réglages : référentiels et comptes). /admin/clients : ancienne adresse de la liste des clients.
  {
    path: "/admin",
    element: <Navigate to="/admin/usage-taxonomy" replace />,
  },
  {
    path: "/admin/clients",
    element: <Navigate to="/clients" replace />,
  },
  {
    path: "/admin/usage-taxonomy",
    element: <UsageTaxonomyPage />,
  },
  {
    path: "/admin/building-types",
    element: <BuildingTypesPage />,
  },
  {
    path: "/admin/machine-types",
    element: <MachineTypesPage />,
  },
  {
    path: "/admin/users",
    element: <UsersAdminPage />,
  },

  {
    path: "/compte",
    element: <AccountPagePage />,
  },

  // Comptes (pages publiques : cf. PUBLIC_PATH dans auth/AuthGate.js)
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/mot-de-passe-oublie",
    element: <ForgotPasswordPage />,
  },
  {
    path: "/invitation/:token",
    element: <SetPasswordPage purpose="invite" />,
  },
  {
    path: "/reset/:token",
    element: <SetPasswordPage purpose="reset" />,
  },

  // Dashboard et plan d'action
  {
    path: "/client/:client_id",
    element: <ClientDashboardPage />,
  },
  {
    path: "/client/:client_id/:building_id",
    element: <ClientBuildingDashboardPage />,
  },
  {
    path: "/client/:building_id/equipments",
    element: <ClientEquipmentsPage />,
  },
  {
    path: "/client/:building_id/usages",
    element: <ClientUsagesPage />,
  },
  {
    path: "/client/:client_id/:building_id/action_plan",
    element: <ClientActionPlanPage />
  },
  {
    path: "/client/:client_id/:building_id/action_plan_v2",
    element: <ClientActionPlanV2Page />
  },
  {
    path: "/client/:client_id/:building_id/action_plan_v2/hydro-efficient-equipment",
    element: <HydroEfficientEquipmentModulePage />
  },
  {
    path: "/client/:client_id/:building_id/action_plan_v2/rainwater-harvesting",
    element: <RainwaterHarvestingModulePage />
  },
  {
    path: "/client/:client_id/:building_id/action_plan_v2/reut",
    element: <ReutModulePage />
  },
  {
    path: "/client/:client_id/:building_id/progress",
    element: <AuditProgressPagePage />
  },
  {
    path: "/client/:building_id/progress",
    element: <AuditProgressPagePage />
  },
  // Audit
  {
    path: "/audit",
    element: <AuditPageCreationClientComponent />
  },
  {
    path: "/audit/:id_client",
    element: <AuditPageCreationBuildingComponent />
  },
  {
    path: "/audit/:id_client/:id_building",
    element: <AuditPageCreationSectionsAndRoomsComponent />
  },
  {
    path: "/audit/add_equipment/:id_client/:id_building/:id_section/:id_room",
    element: <AuditPageCreationWaterpointComponent />
  },
  {
    path: "/audit/:id_client/:id_building/:id_section/:id_room/:id_equipment",
    element: <AuditPageModifyWaterpointComponent />
  },
]);



// « Récemment ouverts » de l'accueil : chaque navigation vers un bâtiment est mémorisée.
recordVisit(window.location.pathname);
router.subscribe((state) => recordVisit(state.location.pathname));

function HomePage() {
  const navigate = useNavigate();

  return (
    <Fragment>
      <div className='app-container'>
        <div className='app-template-organisation'>
          <NavBar></NavBar>
          <MainPage></MainPage>
        </div>
      </div>
    </Fragment>
  );
}

function ClientsListPage() {
  const navigate = useNavigate();

  return (
    <Fragment>
      <div className='app-container'>
        <div className='app-template-organisation'>
          <NavBar></NavBar>
          <ClientsList></ClientsList>
        </div>
      </div>
    </Fragment>
  );
}

function UsageTaxonomyPage() {
  return (
    <Fragment>
      <div className='app-container'>
        <div className='app-template-organisation'>
          <NavBar></NavBar>
          <AdminTabs></AdminTabs>
          <UsageTaxonomy></UsageTaxonomy>
        </div>
      </div>
    </Fragment>
  );
}

function BuildingTypesPage() {
  return (
    <Fragment>
      <div className='app-container'>
        <div className='app-template-organisation'>
          <NavBar></NavBar>
          <AdminTabs></AdminTabs>
          <BuildingTypes></BuildingTypes>
        </div>
      </div>
    </Fragment>
  );
}

function AccountPagePage() {
  return (
    <Fragment>
      <div className='app-container'>
        <div className='app-template-organisation'>
          <NavBar></NavBar>
          <AccountPage></AccountPage>
        </div>
      </div>
    </Fragment>
  );
}

function UsersAdminPage() {
  return (
    <Fragment>
      <div className='app-container'>
        <div className='app-template-organisation'>
          <NavBar></NavBar>
          <AdminTabs></AdminTabs>
          <UsersAdmin></UsersAdmin>
        </div>
      </div>
    </Fragment>
  );
}

function MachineTypesPage() {
  return (
    <Fragment>
      <div className='app-container'>
        <div className='app-template-organisation'>
          <NavBar></NavBar>
          <AdminTabs></AdminTabs>
          <MachineTypes></MachineTypes>
        </div>
      </div>
    </Fragment>
  );
}

function ClientDashboardPage() {
  const navigate = useNavigate();

  return (
    <Fragment>
      <div className='app-container'>
        <div className='app-template-organisation'>
          <NavBar></NavBar>
          <ClientDashboard navigate={navigate}></ClientDashboard>
        </div>
      </div>
    </Fragment>
  );
}

function ClientBuildingDashboardPage() {
  const navigate = useNavigate();
  const { client_id, building_id } = useParams();

  return (
    <Fragment>
      <div className='app-container'>
        <div className='app-template-organisation'>
          <NavBar></NavBar>
          <AuditProgressBar buildingId={building_id} clientId={client_id} />
          <ClientBuildingDashboard navigate={navigate}></ClientBuildingDashboard>
        </div>
      </div>
    </Fragment>
  );
}

function ClientEquipmentsPage() {
  const location = useLocation();
  const { building_id } = useParams();
  const { equipments } = location.state || {};

  return (
    <Fragment>
      <div className='app-container'>
        <div className='app-template-organisation'>
          <NavBar></NavBar>
          <AuditProgressBar buildingId={building_id} />
          <ClientEquipments equipments={equipments}></ClientEquipments>
        </div>
      </div>
    </Fragment>
  );
}

function ClientUsagesPage() {
  const location = useLocation();
  const { building_id } = useParams();
  const { usages } = location.state || {};

  return (
    <Fragment>
      <div className='app-container'>
        <div className='app-template-organisation'>
          <NavBar></NavBar>
          <AuditProgressBar buildingId={building_id} />
          <ClientUsages usages={usages}></ClientUsages>
        </div>
      </div>
    </Fragment>
  );
}

function ClientActionPlanPage() {
  const navigate = useNavigate();
  const { client_id, building_id } = useParams();

  return (
    <Fragment>
      <div className='app-container'>
        <div className='app-template-organisation'>
          <NavBar></NavBar>
          <AuditProgressBar buildingId={building_id} clientId={client_id} />
          <ClientActionPlan navigate={navigate}></ClientActionPlan>
        </div>
      </div>
    </Fragment>
  );
}

function ClientActionPlanV2Page() {
  const navigate = useNavigate();
  const { client_id, building_id } = useParams();

  return (
    <Fragment>
      <div className='app-container'>
        <div className='app-template-organisation'>
          <NavBar></NavBar>
          <AuditProgressBar buildingId={building_id} clientId={client_id} />
          <ClientActionPlanV2 navigate={navigate}></ClientActionPlanV2>
        </div>
      </div>
    </Fragment>
  );
}

function HydroEfficientEquipmentModulePage() {
  const navigate = useNavigate();
  const { client_id, building_id } = useParams();

  return (
    <Fragment>
      <div className='app-container'>
        <div className='app-template-organisation'>
          <NavBar></NavBar>
          <AuditProgressBar buildingId={building_id} clientId={client_id} />
          <HydroEfficientEquipmentModule navigate={navigate}></HydroEfficientEquipmentModule>
        </div>
      </div>
    </Fragment>
  );
}

function RainwaterHarvestingModulePage() {
  const navigate = useNavigate();
  const { client_id, building_id } = useParams();

  return (
    <Fragment>
      <div className='app-container'>
        <div className='app-template-organisation'>
          <NavBar></NavBar>
          <AuditProgressBar buildingId={building_id} clientId={client_id} />
          <RainwaterHarvestingModule navigate={navigate}></RainwaterHarvestingModule>
        </div>
      </div>
    </Fragment>
  );
}

function ReutModulePage() {
  const navigate = useNavigate();
  const { client_id, building_id } = useParams();

  return (
    <Fragment>
      <div className='app-container'>
        <div className='app-template-organisation'>
          <NavBar></NavBar>
          <AuditProgressBar buildingId={building_id} clientId={client_id} />
          <ReutModule navigate={navigate}></ReutModule>
        </div>
      </div>
    </Fragment>
  );
}

function CbsSitesToolPage() {
  return (
    <Fragment>
      <div className='app-container'>
        <div className='app-template-organisation'>
          <NavBar></NavBar>
          <CbsSitesPage />
        </div>
      </div>
    </Fragment>
  );
}

function WaterOriginPagePage() {
  return (
    <Fragment>
      <div className='app-container'>
        <div className='app-template-organisation'>
          <NavBar></NavBar>
          <WaterOriginPage />
        </div>
      </div>
    </Fragment>
  );
}

function AuditProgressPagePage() {
  return (
    <Fragment>
      <div className='app-container'>
        <div className='app-template-organisation'>
          <NavBar></NavBar>
          <AuditProgressPage />
        </div>
      </div>
    </Fragment>
  );
}

function AuditPageCreationClientComponent() {
  const navigate = useNavigate();

  return (
    <Fragment>
      <div className='app-container'>
        <div className='app-template-organisation'>
          <NavBar></NavBar>
          <AuditPageCreationClient navigate={navigate}></AuditPageCreationClient>
        </div>
      </div>
    </Fragment>
  );
}

function AuditPageCreationBuildingComponent() {
  const navigate = useNavigate();

  return (
    <Fragment>
      <div className='app-container'>
        <div className='app-template-organisation'>
          <NavBar></NavBar>
          <AuditPageCreationBuilding navigate={navigate}></AuditPageCreationBuilding>
        </div>
      </div>
    </Fragment>
  );
}

function AuditPageCreationSectionsAndRoomsComponent() {
  const navigate = useNavigate();
  const { id_client, id_building } = useParams();

  return (
    <Fragment>
      <div className='app-container'>
        <div className='app-template-organisation'>
          <NavBar></NavBar>
          <AuditProgressBar buildingId={id_building} clientId={id_client} />
          <AuditPageCreationSectionsAndRooms navigate={navigate}></AuditPageCreationSectionsAndRooms>
        </div>
      </div>
    </Fragment>
  );
}

function AuditPageCreationWaterpointComponent() {
  const { id_client, id_building } = useParams();

  return (
    <Fragment>
      <div className='app-container'>
        <div className='app-template-organisation'>
          <NavBar></NavBar>
          <AuditProgressBar buildingId={id_building} clientId={id_client} />
          <WaterpointForm />
        </div>
      </div>
    </Fragment>
  );
}

function AuditPageModifyWaterpointComponent() {
  const { id_client, id_building } = useParams();

  return (
    <Fragment>
      <div className='app-container'>
        <div className='app-template-organisation'>
          <NavBar></NavBar>
          <AuditProgressBar buildingId={id_building} clientId={id_client} />
          <WaterpointForm />
        </div>
      </div>
    </Fragment>
  );
}


// Reloading/closing/going back while offline stops the app from loading at
// all until connectivity returns (no service worker precaches the app shell
// yet), regardless of whether anything on the current page is unsaved — so
// this warns unconditionally on !isOnline, app-wide, on top of the
// per-page/per-form "unsaved changes" warnings that already exist.
function OfflineUnloadGuard({ children }) {
  const { isOnline } = useOnlineStatus();
  useBeforeUnloadWarning(!isOnline);
  return children;
}

function App() {
  return (
    <ErrorBoundary>
      <OnlineStatusProvider>
        <AuthProvider>
          <OfflineUnloadGuard>
            <AuthGate>
              <RouterProvider router={router} />
            </AuthGate>
          </OfflineUnloadGuard>
        </AuthProvider>
      </OnlineStatusProvider>
    </ErrorBoundary>
  );
}

export default App;